import React, { forwardRef } from 'react';
import { FormControl, FormControlLabel } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { Neutrals } from '../../color-palette/colors';

import type { FieldBaseProps, FieldIds } from './field.types';
import { FieldHelperText } from './FieldShell';

export type BooleanFieldLayout = 'inline' | 'row';

export interface BooleanFieldShellProps extends Omit<FieldBaseProps, 'id' | 'hideLabel' | 'describedById' | 'size' | 'hideRequiredMark'> {
  ids: FieldIds;
  control: React.ReactElement;
  layout?: BooleanFieldLayout;
}

const rowLabelSx = (theme: Theme): SystemStyleObject<Theme> => ({
  marginInline: 0,
  justifyContent: 'space-between',
  inlineSize: '100%',
  gap: 3,
  '@media (pointer: coarse)': { minBlockSize: theme.controlHeight.medium },
  '& .MuiFormControlLabel-label': { ...theme.typography.highlight, color: Neutrals[900] },
});

export const BooleanFieldShell = forwardRef<HTMLDivElement, BooleanFieldShellProps>(function BooleanFieldShell(
  { ids, control, label, helperText, error, required, disabled, fullWidth = true, className, sx, layout = 'inline' },
  ref,
) {
  return (
    <FormControl ref={ref} error={error} disabled={disabled} required={required} fullWidth={fullWidth} className={className} sx={sx}>
      <FormControlLabel
        label={label}
        control={control}
        labelPlacement={layout === 'row' ? 'start' : 'end'}
        sx={layout === 'row' ? rowLabelSx : undefined}
      />
      <FieldHelperText ids={ids} helperText={helperText} />
    </FormControl>
  );
});
